// https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate

import {useReducer} from 'react';

export default function useForceUpdate() {
    return useReducer(x => x + 1, 0)[1] as () => void;
}
